function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

module.exports = _cloneRegExp;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_cloneRegExp.js
// module id = 911
// module chunks = 0